export const roles = [
  // { name: 'Individual', value: 'individual' },
  { name: 'Expert', value: 'expert' },
  { name: 'Business', value: 'business' },
  { name: 'Investor', value: 'investor' },
];
